import { obtenerCatalogo } from "../catalogos/listas/obtenerCatalogo";

/**
 * Método que retorna el nombre de la area
 * @param {Number} idArea 
 * @returns String de la area
 */
export const obtenerNombreArea = async idArea => {
    let nombreLocalidad = String();
    try {
        const lista = await obtenerCatalogo("/api/area/lista", "Imposible obtener catálogo: Áreas");
        for (let i = 0; i < lista.length; i++) {
            if (Number(lista[i].idArea) === Number(idArea)) {
                nombreLocalidad = lista[i].nombreArea.toUpperCase();
                break;
            }
        }
        return nombreLocalidad;
    }
    catch (error) {
        return nombreLocalidad;
    }
}